import React, { useEffect, useState } from 'react';
import { Button, Snackbar } from '@mui/material';
import { applyUpdate } from '../../serviceWorkerRegistration';

/** "New version available" notice; updating reloads the app on the new build. */
const UpdatePrompt = () => {
  const [worker, setWorker] = useState(null);

  useEffect(() => {
    const onUpdate = (event) => setWorker(event.detail);
    window.addEventListener('sw:update', onUpdate);
    return () => window.removeEventListener('sw:update', onUpdate);
  }, []);

  return (
    <Snackbar
      open={Boolean(worker)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message="A new version of MangroveCollect is available."
      action={
        <>
          <Button color="inherit" size="small" onClick={() => setWorker(null)}>Later</Button>
          <Button color="secondary" variant="contained" size="small" onClick={() => applyUpdate(worker)}>Update</Button>
        </>
      }
    />
  );
};

export default UpdatePrompt;
